import { createTheme } from '@mui/material'
import {
  generateFontFace,
  reportEditorEmbeddedFonts,
  sofiaProMedium,
  sofiaProSemiBold,
} from 'src/components/theme/fonts'
import { muiPallete } from 'src/components/theme/colors'
import { borderRadius, spacing } from 'src/components/theme/shapes'
import * as typographies from 'src/components/theme/typographies'

declare module '@mui/material/styles' {
  interface TypographyVariants {
    stat1: React.CSSProperties
    header1: React.CSSProperties
    header2: React.CSSProperties
    header3: React.CSSProperties
    header3s: React.CSSProperties
    title1: React.CSSProperties
    title2: React.CSSProperties
    title2l: React.CSSProperties
    title2m: React.CSSProperties
    textlg: React.CSSProperties
    textlgm: React.CSSProperties
    textmd: React.CSSProperties
    textmdm: React.CSSProperties
    text1: React.CSSProperties
    text1m: React.CSSProperties
    text2: React.CSSProperties
    text2m: React.CSSProperties
    text3: React.CSSProperties
    text3m: React.CSSProperties
    caption1: React.CSSProperties
    caption1m: React.CSSProperties
    caption1sm: React.CSSProperties
  }

  interface TypographyVariantsOptions {
    poster?: React.CSSProperties
    stat1?: React.CSSProperties
    header1?: React.CSSProperties
    header2?: React.CSSProperties
    header3?: React.CSSProperties
    header3s?: React.CSSProperties
    title1?: React.CSSProperties
    title2?: React.CSSProperties
    title2l?: React.CSSProperties
    title2m?: React.CSSProperties
    textlg?: React.CSSProperties
    textlgm?: React.CSSProperties
    textmd?: React.CSSProperties
    text1?: React.CSSProperties
    text1m?: React.CSSProperties
    text2?: React.CSSProperties
    text2m?: React.CSSProperties
    text3?: React.CSSProperties
    text3m?: React.CSSProperties
    caption1?: React.CSSProperties
    caption1m?: React.CSSProperties
    caption1sm?: React.CSSProperties
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    stat1: true
    header1: true
    header1m: true
    header2: true
    header3: true
    header3s: true
    title1: true
    title2: true
    title2l: true
    title2m: true
    textlg: true
    textlgm: true
    textmd: true
    textmdm: true
    text1: true
    text1m: true
    text2: true
    text2m: true
    text3: true
    text3m: true
    caption1: true
    caption1m: true
    caption1sm: true
  }
}

export const muiTheme = createTheme({
  palette: muiPallete,
  spacing: spacing,
  typography: {
    fontFamily: sofiaProMedium.fontFamily,
    fontSize: 11,
    ...typographies,
  },
  shape: {
    borderRadius: borderRadius,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        ${generateFontFace(sofiaProMedium)}
        ${generateFontFace(sofiaProSemiBold)}
        ${reportEditorEmbeddedFonts()}
      `,
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          stat1: 'p',
          header1: 'h1',
          header1m: 'h1',
          header2: 'h2',
          header3: 'h3',
          header3s: 'h3',
          title1: 'p',
          title2: 'p',
          title2l: 'p',
          title2m: 'p',
          textlg: 'p',
          textlgm: 'p',
          textmd: 'p',
          text1: 'p',
          text1m: 'p',
          text2: 'p',
          text2m: 'p',
          text3: 'p',
          text3m: 'p',
          caption1: 'p',
          caption1m: 'p',
          caption1sm: 'p',
        },
      },
    },
  },
})
